<template>
  <footer class="footer">
    <div class="container-fluid d-flex flex-wrap justify-content-between">
      <nav>
        <ul>
          <li>
            <router-link :to="{ path: '/admin' }">Dashboard</router-link>
          </li>
        </ul>
      </nav>
      <div class="mt-4">
        Desarrollado por
        <a href="https://polluxcoop.com" target="_blank">Pollux</a>
      </div>
    </div>
  </footer>
</template>
<script>
export default {};
</script>
<style></style>
